import React, { useState, useRef, useEffect } from 'react';
import './Video.scss';

export default (props) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);


  const handlePlayPauseVideo = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
      setShowControls(true); 
    }
    setIsPlaying(!isPlaying);
  };


  useEffect(() => {
    const video = videoRef.current;

    const handlePause = () => {
      setIsPlaying(false);
      setShowControls(false); 
    };

    const handleFullscreenChange = () => {
      if (document.fullscreenElement === null && video && !video.paused) {
        setIsPlaying(true); 
        setShowControls(true); 
      }
    };

    if (video) {
      video.addEventListener('pause', handlePause);
      document.addEventListener('fullscreenchange', handleFullscreenChange);
    }
  
    return () => {
      if (video) {
        video.removeEventListener('pause', handlePause);
      }
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  return (
    <div className="home__video__vid">
      <video
        ref={videoRef}
        controls={showControls}
        poster={props.poster}
        playsInline 
      >
      {props.deskSrc && (
        <source src={props.deskSrc} type="video/mp4" media="(min-width:640px)" />
      )}
        <source src={props.src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {!isPlaying && (
        <button className="play-button" onClick={handlePlayPauseVideo}>
          ▶
        </button>
      )}
    </div>
  );
};
